import request from '@/utils/request'

// 菜品列表
export const foodList = function (data) {
    return request({
        url: '/api/food/getList',
        method: 'post',
        data: data
    })
}
// 菜品添加、修改
export const foodSave = function (data) {
    return request({
        url: '/api/food/sendSave',
        method: 'post',
        data: data
    })
}
// 菜品删除
export const foodDel = function (data) {
    return request({
        url: '/api/food/sendDel',
        method: 'post',
        data: data
    })
}

// 菜品 上下架 设置
export const foodStatus = function (data) {
    return request({
        url: '/api/food/foodStatus',
        method: 'post',
        data: data
    })
}

// 菜品 外卖/堂食 设置
export const setFood = function (data) {
    return request({
        url: '/api/food/setFood',
        method: 'post',
        data: data
    })
}

// 菜品分类
export const foodCategory = function (data) {
    return request({
        url: '/api/food/category',
        method: 'post',
        data: data
    })
}

// 菜品分类添加/修改
export const foodCategorySave = function (data) {
    return request({
        url: '/api/food/categorySave',
        method: 'post',
        data: data
    })
}

// 菜品分类删除
export const foodCategoryDel = function (data) {
    return request({
        url: '/api/food/categoryDel',
        method: 'post',
        data: data
    })
}

// 菜品条件分类
export const foodRaiseCategory = function (data) {
    return request({
        url: '/api/food/raiseCategory',
        method: 'post',
        data: data
    })
}
// 菜品条件分类删除
export const foodRaiseCategoryDel = function (data) {
    return request({
        url: '/api/food/raiseCategoryDel',
        method: 'post',
        data: data
    })
}

// 菜品条件添加/修改
export const foodRaiseCategorySave = function (data) {
    return request({
        url: '/api/food/raiseCategorySave',
        method: 'post',
        data: data
    })
}

// 菜品条件
export const foodRaise = function (data) {
    return request({
        url: '/api/food/raise',
        method: 'post',
        data: data
    })
}

// 菜品条件添加/修改
export const foodRaiseSave = function (data) {
    return request({
        url: '/api/food/raiseSave',
        method: 'post',
        data: data
    })
}

// 菜品条件删除
export const foodRaiseDel = function (data) {
    return request({
        url: '/api/food/raiseDel',
        method: 'post',
        data: data
    })
}

// 附加条件上下架
export const foodRaiseStatus = function (data) {
    return request({
        url: '/api/food/raiseStatus',
        method: 'post',
        data: data
    })
}

export default {
    foodList,
    foodSave,
    foodDel,
    foodStatus,
    setFood,

    foodCategory,
    foodCategorySave,
    foodCategoryDel,

    foodRaiseCategory,
    foodRaiseCategoryDel,
    foodRaiseCategorySave,

    foodRaise,
    foodRaiseSave,
    foodRaiseDel,
    foodRaiseStatus
}
